import {inject, Provider, Type} from '@angular/core';
import {ControlRef} from '@aviary/forms/fields/form-fields.types';
import {CONTROL_REF} from '@aviary/injection-tokens/aviary-only.tokens';

/*
  All custom form field components that implement ControlRef should use this to provide the CONTROL_REF token so that we can find form fields within content
  children of other components.
*/
export function provideControlRefTokenFor<T extends ControlRef>(type: Type<T>): Provider {
  return {
    provide: CONTROL_REF,
    useFactory: () => inject(type, {self: true})
  };
}
